import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sectionStore } from '../../features/dashboard/SectionOneSlice';
import { archiveIndex } from '../../features/dashboard/ArchiveSlice';
import Header from './Header';
import Input from '../form/Input';
import Select from '../form/Select';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';
import Access from '../../Access'

function ArchiveSectionOne () {

    const dispatch = useDispatch();
    const [status, setStatus] = useState(false)
    const [archive, setArchive] = useState('')
    const [title, setTitle] = useState('')
    const [loading, setLoading] = useState(true)
    let {
        archiveSectionOneLoading,
        archiveSectionOneSuccess,
        message,
        errorArchives,
        errorTitle,
    } = useSelector((state) => state.sectionOne)
    const {archives} = useSelector(state => state.archive)

    useEffect(() => {
        // Handle Loading page Before Load DOM
        status === true ? setLoading(true) : setLoading(false)

        dispatch(archiveIndex(localStorage.getItem('token')));
        if(archiveSectionOneSuccess === true && status === true) {
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setStatus(false)
            setLoading(false)
            setTitle('')
            setArchive('')
            message = ''
        } else {
          
            setStatus(false)
            setLoading(false) 
          
        }
        message = ''
        return () => {
            message = ''
        }

    },[archiveSectionOneSuccess, message])

    const sectionOneHandler = (event) => {
        event.preventDefault();
        setLoading(true)
        setStatus(true)
        const data = {
            'store_id': archive,
            'title': title,
            'access': localStorage.getItem('access')
        }
        dispatch(sectionStore(data));
    }
    return (
        <>
        { loading ? (<Loading />) : null }
        {
             message == 'access' ? <Access /> :
             <form className="text-end">
                <div className='row g-2 p-5 my-5'>        
                    <Header title={'ثبت بخش های انبار - بخش اصلی'} />  
                    <div className="col-6 ">
                        <Select
                            key='1'
                            tab='1'
                            col='col-12'
                            name=''
                            title='انتخاب انبار'
                            value={archive}
                            errorName={errorArchives}
                            onchange={(e) => setArchive(e.target.value)}
                            status='1'
                            data={archives}
                            focus='1'
                        />
                    </div>
                    <div className="col-6 ">
                        <Input 
                            key='2'
                            tab='2'
                            col='col-12'
                            type='text'
                            maxlength={255}
                            name='number'
                            value={title}
                            title='عنوان'
                            onchange={(e) => setTitle(e.target.value)}
                            placeholder='مانند : ساختمان کویر موتور' 
                            errorName={errorTitle}
                        />   
                    </div>
                    <div className="row g-2 px-0 mt-4 mb-0">
                        <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                            <Button 
                                tab='3'
                                title='ثبت بخش اصلی'
                                design="position-relative px-4 py-1 btn btn-dark fw-bold"
                                event={sectionOneHandler}
                            />
                        </div>
                    </div>
                </div>
            </form>
        }
        
        </>
    )
}

export default ArchiveSectionOne;